// extracted by mini-css-extract-plugin
export default {"productDescription":"Nca-z","featuredDescription":"Oca-z","description":"Pca-z","more":"Qca-z","descriptionSku":"Rca-z"};